<template>
  <v-container fluid class="pa-0 my-4">
    <v-row>
      <v-col cols="12" md="7" class="pt-0">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.activateAccountPageMain}`)
          "
          aspect-ratio="2"
          alt="house and funeral"
          class="main-image"
        />
      </v-col>
      <v-col cols="10" md="4" offset="1" offset-md="0" class="pl-md-0">
        <h2>Your first step towards protecting your legacy!</h2>
        <ActivateAccountForm
          v-if="isActivationLink"
          :verify-user-link-code="verifyUserLinkCode"
        />
        <SignUpForm v-if="isReferralLink" />
      </v-col>
    </v-row>

    <h2 class="mt-6 mb-3 question-heading">How do you protect your legacy?</h2>
    <v-row>
      <v-col cols="12" md="4" lg="3" offset-md="2" offset-lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage1}`)"
          aspect-ratio="1"
          alt="will"
          class="activate-account-images"
        />
        <p class="blurb">have a valid will in place</p>
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage2}`)"
          aspect-ratio="1"
          alt="money"
          class="activate-account-images"
        />
        <p class="blurb">
          ensure there is enough cash in your estate immediately upon your
          passing
        </p>
      </v-col>
    </v-row>

    <h2 class="mt-6 question-heading">
      Why should you have a will &amp; why do you need cash?
    </h2>
    <v-row>
      <v-col cols="12" class="pb-0">
        <h3>You need cash to ensure that:</h3>
      </v-col>
      <v-col cols="12" md="4" lg="3" offset-md="2" offset-lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage3}`)"
          aspect-ratio="1"
          alt="tombstone"
          class="activate-account-images"
        />
        <p class="blurb">your funeral expenses are taken care of</p>
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage4}`)"
          aspect-ratio="1"
          alt="sold house"
          class="activate-account-images"
        />
        <p class="blurb">
          your family won't lose the assets you left, due to it being sold to
          cover estate administration costs
        </p>
      </v-col>
      <v-col cols="12" class="pt-0">
        <h2 class="primary--text">
          How much cash do you need?
          <br />
          We help you to calculate your estimated estate administration costs.
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pb-0">
        <h3>You need a valid will to ensure that:</h3>
      </v-col>
      <v-col cols="12" md="4" lg="3" offset-md="2" offset-lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage5}`)"
          aspect-ratio="1"
          alt="will being read"
          class="activate-account-images"
        />
        <p class="blurb">your wishes are carried out upon your passing</p>
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <v-img
          :src="require(`@/assets/${whitelabel.images.activateAccountPage6}`)"
          aspect-ratio="1"
          alt="executor"
          class="activate-account-images"
        />
        <p class="blurb">
          the process around the administration of your estate is managed
          swiftly &amp; professionally
        </p>
      </v-col>
    </v-row>

    <v-btn rounded large depressed color="primary" @click="getStarted()">
      Get Started
    </v-btn>
  </v-container>
</template>

<script>
  import ActivateAccountForm from './ActivateAccountForm.vue';
  import SignUpForm from '../sign_up/SignUpForm.vue';

  export default {
    name: 'ActivateAccountPage',
    components: {
      ActivateAccountForm,
      SignUpForm,
    },
    props: {
      verifyUserLinkCode: {
        required: true,
        type: Object,
      },
    },
    computed: {
      isActivationLink() {
        return this.verifyUserLinkCode.linkType == 'ACTIVATION';
      },
      isReferralLink() {
        return this.verifyUserLinkCode.linkType == 'REFERRAL';
      },
    },
    methods: {
      getStarted() {
        const firstInputField = document.getElementById(
          'landing_page_first_input'
        );
        firstInputField.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => this.$nextTick().then(firstInputField.focus()), 700);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .activate-account-images {
    max-width: 170px;
    margin: 0 auto 8px auto;
  }

  .blurb {
    width: 60%;
    margin: auto;
  }

  .question-heading {
    font-size: 30px;
  }

  @media screen and (max-width: 960px) and (min-width: 600px) {
    .blurb {
      width: 35%;
      margin: auto;
    }
  }
</style>
